const HighlightOption = {
  YELLOW: 'marker-yellow',
  GREEN: 'marker-green',
  BLUE: 'marker-blue',
  PINK: 'marker-pink'
};

export { HighlightOption };
